import { useEffect, useRef, ChangeEvent } from 'react';
import { TextField } from '../TextField';
import { Icon } from '../Icon';

type Props = {
  className?: string;
  onChange: (value: string) => void;
  name?: string;
  error?: boolean;
  value: string;
  disabled?: boolean;
  min?: string; // Minimum time (HH:mm format)
  step?: number; // Step in seconds (e.g., 900 for 15 minutes)
};

export function TimePicker({
  className = '',
  onChange,
  name,
  error = false,
  value,
  disabled = false,
  min,
  step,
}: Props) {
  const timeInputRef = useRef<HTMLInputElement>(null);

  const handleTimeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedTime = event.target.value;
    onChange(selectedTime);
  };

  const openTimeInput = () => {
    if (timeInputRef.current && !disabled) {
      timeInputRef.current.click();
      timeInputRef.current.focus();
    }
  };

  useEffect(() => {
    const timeInput = timeInputRef.current;
    const clickHandler = function () {
      if (timeInput && !disabled) {
        timeInput.showPicker?.();
      }
    };
    if (timeInput) {
      timeInput.addEventListener('click', clickHandler);
    }
    return () => {
      if (timeInput) {
        timeInput.removeEventListener('click', clickHandler);
      }
    };
  }, [disabled]);

  return (
    <div className="relative" onClick={openTimeInput}>
      <input
        type="time"
        ref={timeInputRef}
        onChange={handleTimeChange}
        name={name}
        value={value}
        disabled={disabled}
        min={min}
        step={step}
        className="cursor-pointer absolute rounded-[8px] h-0 w-0 bottom-0 focus:ring-0 ring-0 opacity-0"
      />
      <TextField
        name={name || ''}
        value={value || '-- : --'}
        onChange={() => { }}
        readOnly
        disabled={disabled}
        className={className}
        error={error}
        inputClass="py-3"
        prefix={
          <div className="pl-2.5">
            <Icon icon={'clock'} />
          </div>
        }
      />
    </div>
  );
}
